'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PAYMENT_CARD_CLEAR = exports.PAYMENT_SET_PRORATE_DATE = exports.PAYMENT_UPCOMING_FAILED = exports.PAYMENT_UPCOMING_FETCHED = exports.PAYMENT_UPCOMING_FETCHING = exports.PAYMENT_COUPON_CLEAR = exports.PAYMENT_COUPON_FAILED = exports.PAYMENT_COUPON_FETCHED = exports.PAYMENT_COUPON_FETCHING = exports.PAYMENT_PLANS_FAILED = exports.PAYMENT_PLANS_FETCHED = exports.PAYMENT_PLANS_FETCHING = exports.PAYMENT_SET_VIEW_STATE = exports.CARD_UPDATE_FORM_FIELDS = exports.PAYMENT_VIEW_STATES = exports.PAYMENT_FORM_FIELDS = exports.PAYMENT_FORM_NAME = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _creditCardConstants = require('../../../components/form/creditCard/creditCardConstants');

var PAYMENT_FORM_NAME = exports.PAYMENT_FORM_NAME = 'payment';
var PAYMENT_FORM_FIELDS = exports.PAYMENT_FORM_FIELDS = _extends({}, _creditCardConstants.CREDIT_CARD_FORM_FIELDS, {
    plan: {
        name: 'plan',
        type: 'radio',
        required: true
    },
    coupon: {
        name: 'coupon',
        type: 'text'
    },
    prorateDate: {
        name: 'prorateDate',
        type: 'text'
    }
});

var PAYMENT_VIEW_STATES = exports.PAYMENT_VIEW_STATES = {
    CARD_FORM: 'CARD_FORM',
    PROCESSING: 'PROCESSING',
    SUCCESS: 'SUCCESS'
};

var CARD_UPDATE_FORM_FIELDS = exports.CARD_UPDATE_FORM_FIELDS = _creditCardConstants.CREDIT_CARD_FORM_FIELDS;

var PAYMENT_SET_VIEW_STATE = exports.PAYMENT_SET_VIEW_STATE = 'PAYMENT_SET_VIEW_STATE';
var PAYMENT_PLANS_FETCHING = exports.PAYMENT_PLANS_FETCHING = 'PAYMENT_PLANS_FETCHING';
var PAYMENT_PLANS_FETCHED = exports.PAYMENT_PLANS_FETCHED = 'PAYMENT_PLANS_FETCHED';
var PAYMENT_PLANS_FAILED = exports.PAYMENT_PLANS_FAILED = 'PAYMENT_PLANS_FAILED';

var PAYMENT_COUPON_FETCHING = exports.PAYMENT_COUPON_FETCHING = 'PAYMENT_COUPON_FETCHING';
var PAYMENT_COUPON_FETCHED = exports.PAYMENT_COUPON_FETCHED = 'PAYMENT_COUPON_FETCHED';
var PAYMENT_COUPON_FAILED = exports.PAYMENT_COUPON_FAILED = 'PAYMENT_COUPON_FAILED';
var PAYMENT_COUPON_CLEAR = exports.PAYMENT_COUPON_CLEAR = 'PAYMENT_COUPON_CLEAR';

var PAYMENT_UPCOMING_FETCHING = exports.PAYMENT_UPCOMING_FETCHING = 'PAYMENT_UPCOMING_FETCHING';
var PAYMENT_UPCOMING_FETCHED = exports.PAYMENT_UPCOMING_FETCHED = 'PAYMENT_UPCOMING_FETCHED';
var PAYMENT_UPCOMING_FAILED = exports.PAYMENT_UPCOMING_FAILED = 'PAYMENT_UPCOMING_FAILED';

var PAYMENT_SET_PRORATE_DATE = exports.PAYMENT_SET_PRORATE_DATE = 'PAYMENT_SET_PRORATE_DATE';

var PAYMENT_CARD_CLEAR = exports.PAYMENT_CARD_CLEAR = 'PAYMENT_CARD_CLEAR';


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/payment/paymentConstants.js
// module id = 202
// module chunks = 0